import { PencilSquareIcon } from "~/ui-library/icons";
import { Body, Button, Icon } from "~/ui-library";
import { editPost } from "~/lib/client/endilApiCalls";

type PostEditCTAButtonProps = {
  children: React.ReactNode;
  postParam: string | number;
};

export const PostEditCTAButton: React.FC<PostEditCTAButtonProps> = ({
  children,
  postParam,
}) => (
  <Button
    className="p-xs text-primary"
    variant="link"
    onClick={async () => {
      const result = await editPost(postParam.toString());
      window.location.href = result.data.redirectTarget;
    }}
  >
    <div className="flex items-center gap-xs">
      <Icon className="fill-transparent" SvgIcon={PencilSquareIcon} />
      <Body bold={true}>{children}</Body>
    </div>
  </Button>
);
